// Constant
import { FAKE_RESPONSE } from 'constant/shared.constant'

// Interfaces
import {
  IHomeBannerApiGetAllResponse,
  IHomeBannerApiGetResponse,
} from 'interfaces/back-office/content-management/home/banner/home-banner-api.interface'

// Moment
import moment from 'moment'

export const HOME_BANNERS: IHomeBannerApiGetAllResponse = {
  ...FAKE_RESPONSE,
  res: {
    message: 'Get Home Banners Success',
    success: '1',
    data: {
      pageNumber: 1,
      itemsPerPage: 10,
      sortColumn: '',
      sortDirection: true,
      totalData: 10,
      list: [
        {
          number: 1,
          id: 1,
          title: 'Banner',
          content: 'Content',
          image: 'base64String',
          status: true,
          createdAt: moment().toString(),
          updatedAt: moment().toString(),
        },
      ],
    },
  },
}

export const HOME_BANNER: IHomeBannerApiGetResponse = {
  ...FAKE_RESPONSE,
  res: {
    message: 'Get Home Banner Success',
    success: '1',
    data: {
      id: 1,
      title: 'Banner',
      content: 'Content',
      image: 'base64String',
      status: true,
      createdAt: moment().toString(),
      updatedAt: moment().toString(),
    },
  },
}
